import React, { useState } from "react";

const EditBio = ({
  handleCloseEditBIo,
  userObject,
  setUserObject,
  isLoading,
  isEidtBio,
  editProfile,
}) => {
  const [newDob, setNewDob] = useState(userObject?.dob || "");
  const [newHeight, setNewHeith] = useState(userObject?.height || null);
  const [newHeightUnit, setNewHeightUnit] = useState(
    userObject?.height_unit || ""
  );
  const [newWeight, setNewWeight] = useState(userObject?.weight || null);
  const [newWeightUnit, setNewWeightUnit] = useState(
    userObject?.weight_unit || ""
  );
  const [newInterests, setNewInterests] = useState([]);
  const [newActivities, setNewActivities] = useState([]);
  const [tempActivities, setTempActivities] = useState("");
  const [tempInterests, setTempInterests] = useState("");

  const handleUpdate = async () => {
    const parsedNewInterests = Array.isArray(newInterests)
      ? newInterests
      : newInterests.length === 0
      ? []
      : JSON.parse(newInterests);

    const parsedNewActivities = Array.isArray(newActivities)
      ? newActivities
      : newActivities.length === 0
      ? []
      : JSON.parse(newActivities);
    isEidtBio
      ? editProfile(
          newDob,
          newWeight,
          newWeightUnit,
          newHeight,
          newHeightUnit,
          undefined,
          undefined,
          undefined
        )
      : editProfile(
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          parsedNewInterests.concat(JSON.parse(userObject?.interests || "[]")),
          parsedNewActivities.concat(
            JSON.parse(userObject?.activities || "[]")
          ),
          undefined
        );

    handleCloseEditBIo();
  };
  // waiting Loader
  const loader = () => {
    return (
      <div class="three-body">
        <div class="three-body__dot"></div>
        <div class="three-body__dot"></div>
        <div class="three-body__dot"></div>
      </div>
    );
  };

  //adding new interests and activities
  const toggleItem = (type) => {
    if (tempActivities !== "" || tempInterests !== "") {
      if (type === "activities") {
        setNewActivities([...newActivities, tempActivities]);
        setTempActivities("");
      } else {
        setNewInterests([...newInterests, tempInterests]);
        setTempInterests("");
      }
    }
  };

  //   removing intersts and activities
  const removeItem = (type, index, removeType) => {
    if (type === "activities") {
      removeType === 1
        ? setNewActivities(newActivities.filter((intr, indx) => indx !== index))
        : setUserObject({
            ...userObject,
            activities: JSON.stringify(
              JSON.parse(userObject.activities).filter(
                (intr, indx) => indx !== index
              )
            ),
          });
    } else {
      removeType === 1
        ? setNewInterests(newInterests.filter((intr, indx) => indx !== index))
        : setUserObject({
            ...userObject,
            interests: JSON.stringify(
              JSON.parse(userObject.interests).filter(
                (intr, indx) => indx !== index
              )
            ),
          });
    }
  };

  return (
    <div className="excercise-modal trainings-modal mt-4 pt-4">
      <i className="fa fa-times" onClick={handleCloseEditBIo}></i>
      <p className="title-small">
        {isEidtBio ? "Edit Bio" : "Edit Intrest and Activities"}
      </p>
      <div className="child-modal ">
        <div className="cont">
          {isEidtBio && (
            <div className="form-group relative">
              <label htmlFor="">Date of Birth</label>
              <input
                type="date"
                value={newDob}
                onChange={(e) => setNewDob(e.target.value)}
                className="form-control input"
              />
              <label htmlFor="" className="mt-2">
                Height
              </label>
              <div className="d-flex justify-content-between gap-3">
                <input
                  type="number"
                  value={newHeight}
                  onChange={(e) => setNewHeith(e.target.value)}
                  className="form-control input"
                />
                <select
                  class="form-select form-select-sm pt-1"
                  onChange={(e) => setNewHeightUnit(e.target.value)}
                  value={newHeightUnit}
                >
                  <option>in</option>
                  <option>ft</option>
                  <option>cm</option>
                  <option>mm</option>
                </select>
              </div>
              <label htmlFor="" className="mt-2">
                Weight
              </label>
              <div className="d-flex justify-content-between gap-3">
                <input
                  type="number"
                  value={newWeight}
                  onChange={(e) => setNewWeight(e.target.value)}
                  className="form-control input "
                />
                <select
                  class="form-select form-select-sm pt-1"
                  onChange={(e) => setNewWeightUnit(e.target.value)}
                  value={newWeightUnit}
                >
                  <option>kg</option>
                  <option>lbs</option>
                </select>
              </div>
            </div>
          )}

          {!isEidtBio && (
            <div className="form-group relative">
              <label htmlFor="">Add Activities</label>
              <div className="d-flex justify-content-between gap-3">
                <input
                  type="text"
                  value={tempActivities}
                  onChange={(e) => setTempActivities(e.target.value)}
                  className="form-control input"
                />
                <button
                  className={`button`}
                  onClick={() => toggleItem("activities")}
                >
                  Add
                </button>
              </div>
              <ul className="edit-activities my-2">
                {userObject?.activities &&
                  JSON.parse(userObject?.activities)?.map((intr, index) => (
                    <li>
                      {intr}
                      <i
                        className="fa-solid fa-trash-can"
                        style={{ marginLeft: "5px" }}
                        onClick={() => removeItem("activities", index, 0)}
                      />
                    </li>
                  ))}
                {newActivities.length > 0 &&
                  newActivities?.map((intr, index) => (
                    <li>
                      {intr}
                      <i
                        className="fa-solid fa-trash-can"
                        style={{ marginLeft: "5px" }}
                        onClick={() => removeItem("activities", index, 1)}
                      />
                    </li>
                  ))}
              </ul>
              <label htmlFor="">Add Interests</label>
              <div className="d-flex justify-content-between gap-3">
                <input
                  type="text"
                  value={tempInterests}
                  onChange={(e) => setTempInterests(e.target.value)}
                  className="form-control input"
                />
                <button
                  className={`button`}
                  onClick={() => toggleItem("interests")}
                >
                  Add
                </button>
              </div>
              <ul className="edit-activities my-2">
                {userObject?.interests &&
                  JSON.parse(userObject?.interests)?.map((intr, index) => (
                    <li>
                      {intr}
                      <i
                        className="fa-solid fa-trash-can"
                        style={{ marginLeft: "5px" }}
                        onClick={() => removeItem("interests", index, 0)}
                      />
                    </li>
                  ))}
                {newInterests.length > 0 &&
                  newInterests?.map((intr, index) => (
                    <li>
                      {intr}
                      <i
                        className="fa-solid fa-trash-can"
                        style={{ marginLeft: "5px" }}
                        onClick={() => removeItem("interests", index, 1)}
                      />
                    </li>
                  ))}
              </ul>
            </div>
          )}
        </div>
        {!isLoading ? (
          <div className="d-flex justify-content-between  form-button ">
            <button className={`button`} onClick={() => handleUpdate()}>
              Update
            </button>{" "}
          </div>
        ) : (
          loader()
        )}
      </div>
    </div>
  );
};

export default EditBio;
